<section class="register-section">
	<header class="row page-header margin-0">
		<div class="container">
			<div class="row">
				<div class="col-md-12">
					<h2 class=title>SIGN UP</h2>
					<p class="hint">Use your invite code to gain access to the SmartProperty.</p>
				</div>
				<div class="col-md-12 ">
					<sp-comm-state [successMessage]="'Sign Up Successfully'" [failedMessage]="'Sign Up failed'" [scrollOnStateChange]="true"
						[scrollItemSelector]="'body'"></sp-comm-state>
				</div>
			</div>
		</div>
	</header>
	<main>
		<form [formGroup]="signUpForm">
			<div class="form-section">
				<div class="container">
					<div class="form-section-container">

						<div class="row">
							<div class="col-md-3">
								<label for="firstName">First Name</label><span class="required">*</span>
							</div>
							<div class="col-md-4">
								<input type="text" class="form-control" formControlName="firstName" placeholder="First Name" maxlength="50" required />
								<sp-field-error [controlName]="'First Name'" [control]="signUpForm?.controls?.firstName"></sp-field-error>
							</div>
						</div>
            <div class="row top-buffer-20">
              <div class="col-md-3">
                <label for="lastName">Last Name</label><span class="required">*</span>
              </div>
              <div class="col-md-4">
                <input type="text" class="form-control" formControlName="lastName" placeholder="Last Name" maxlength="50" required />
                <sp-field-error [controlName]="'Last Name'" [control]="signUpForm?.controls?.lastName"></sp-field-error>
              </div>
            </div>
            <div class="row top-buffer-20">
              <div class="col-md-3">
                <label for="email">Email</label><span class="required">*</span>
              </div>
              <div class="col-md-4">
                <input type="email" class="form-control" formControlName="email" placeholder="Email" maxlength="100" />
                <sp-field-error [controlName]="'Email'" [control]="signUpForm?.controls?.email"></sp-field-error>
              </div>
            </div>

						<div class="row top-buffer-20">
							<div class="col-md-3">
								<label for="password">Password</label><span class="required">*</span>
							</div>
							<div class="col-md-4">
								<input type="password" class="form-control" formControlName="password" #password placeholder="Password" maxlength="20"
								/>
								<sp-field-error [controlName]="'Password'" [control]="signUpForm?.controls?.password"></sp-field-error>
							</div>
							<div class="col-md-5">
								<ol class="password-hint">
									<li>Passwords must have at least six characters that includes: lowercase letters, numbers, and symbols.</li>
								</ol>
							</div>
						</div>
						<div class="row top-buffer-20">
							<div class="col-md-3">
								<label for="confirmPassword">Confirm Password</label><span class="required">*</span>
							</div>
							<div class="col-md-4">
								<input type="password" class="form-control" formControlName="confirmPassword" placeholder="Confirm Password" maxlength="20"
									required />
								<sp-field-error [controlName]="'Confirm Password'" [control]="signUpForm?.controls?.confirmPassword"></sp-field-error>
							</div>
						</div>
						<div class="row top-buffer-20">
							<div class="col-md-3">
								<label for="invitationCode">Invitation Code</label> <span class="required">*</span>
							</div>
							<div class="col-md-4">
								<input type="text" class="form-control" formControlName="invitationCode" placeholder="Code" maxlength="50" required/>
								<sp-field-error [controlName]="'Invitation Code'" [control]="signUpForm?.controls?.invitationCode"></sp-field-error>
							</div>
						</div>
						<div class="row top-buffer-20">
							<div class="col-md-9 offset-md-3">
								<button [disabled]="!signUpForm?.valid || isSubmitting" type="submit" (click)="onSignUp()" class="btn btn-success btn-register">
									<span *ngIf="isSubmitting" class="sp-icon-loader-button-secondary u-alignMiddle"></span>{{isSubmitting? 'Signing Up...': 'Sign Up'}}
								</button>
							</div>
						</div>
						<div class="row top-buffer-20">
							<div class="col-md-9 offset-md-3">
								<span class="hint">* By Clicking 'Sign Up', you agree to our <a [routerLink]="['/terms']">Terms</a> of Use and consent to our <a [routerLink]="['/privacy']">Privacy Policy</a></span>
							</div>
						</div>
					</div>
				</div>
			</div>
		</form>
	</main>
</section>
